import Card from "components/card";

const InfoCard = ({ label, icon, value, span = "" }) => {
    return (
        <Card className={`rounded-xl border ${span}`}>
            <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                    {icon && (
                        <div className="w-4 h-4 flex items-center justify-center muted-text">
                            {icon}
                        </div>
                    )}

                    <p className="text-[10px] uppercase tracking-wide muted-text">
                        {label}
                    </p>
                </div>

                <p className="text-[14px] font-medium title-text break-words">
                    {value ?? "-"}
                </p>
            </div>
        </Card>
    );
};

export default InfoCard;